export const extractErrorMessage = (error) => {
    const data = error?.response?.data;

    if (data) {
        if (data?.error?.details?.errorMessage) {
            return data.error.details.errorMessage;
        }

        if (data?.error?.message) {
            return data.error.message;
        }

        if (data?.message) {
            return data.message;
        }

        if (Array.isArray(data.errors)) {
            return data.errors.map(e => e.message || e).join(", ");
        }

        if (typeof data.errors === "object") {
            return Object.values(data.errors).join(", ");
        }

        if (typeof data === "string") {
            return data;
        }
    }

    return error?.message || "Something went wrong!";
};

export const extractSuccessMessage = (response, fallback) => {
    const data = response?.data;

    return (
        data?.data?.message ||
        data?.data?.successMessage ||
        data?.message ||
        fallback ||
        "Successfully executed the task!"
    );
};
